import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
  CreditBalanceTypeEnum,
  InvoiceType,
  TransactionType,
} from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'credit-balance-type',
  templateUrl: './credit-balance-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class CreditBalanceTypeComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  getMode(value: number) {
    if (!value || value == 0) return '-';
    else if (Object.keys(value).length == 0) {
      return '-';
    } else {
      return CreditBalanceTypeEnum[value];
    }
  }
}
